import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import './index.css';

import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import { hydrateProfileCache } from '@/lib/profileCache';

// Force dark mode for OpenDork terminal UI
document.documentElement.classList.add('dark');

const root = createRoot(document.getElementById('root')!);

function mount() {
  root.render(<App />);
  // Remove the HTML preloader after React has painted.
  requestAnimationFrame(() => {
    document.getElementById('preloader')?.remove();
  });
}

// Seed the in-memory profile mirror from IndexedDB before first paint so
// kind-0 names (greetings, sidebar, etc.) are available synchronously.
// Cap wait so a slow IDB never blocks the shell.
const hydrateCap = 400;
void Promise.race([
  hydrateProfileCache(),
  new Promise<void>((r) => setTimeout(r, hydrateCap)),
]).finally(mount);
